import { default as cssHasPseudo } from './browser';
self.cssHasPseudo = cssHasPseudo;
